import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ToastrService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-container',
  template: `
    <div class="toast-container toast-top-right" aria-live="polite">
      @for (notification of toastr.notifications(); track notification.id) {
        <div
          class="toast toast-{{ notification.kind }}"
          [attr.role]="notification.kind === 'error' ? 'alert' : 'status'"
          tabindex="0"
          (click)="toastr.remove(notification.id)"
          (keydown.enter)="toastr.remove(notification.id)"
        >
          @if (notification.title) {
            <div class="toast-title">{{ notification.title }}</div>
          }
          <div class="toast-message">{{ notification.message }}</div>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  readonly toastr = inject(ToastrService);
}
